<div class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 96px;">
  <div class="mb-4">
    <button type="button" class="btn btn-outline-secondary" (click)="goBack()">← Back to Home</button>
  </div>

  <!-- Page Title on Top -->
  <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-4">What's New in Version 2.0</h1>

  <!-- 1st subsection -->
  <div id="live-monitor" class="wn-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">Introducing the Live NTRIP Connections Monitor – track your connections in real time</h2>
    <img src="assets/images/landing/dashboard_screen.png"
         class="subsection-img"
         alt="Dashboard"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/dashboard_screen.png','Dashboard')">
    <p>Easily track and manage your RTK activity right from the dashboard with our new Live NTRIP Connections Monitor. Instantly see all active RTK Base and Rover connections to your NTRIP mountpoints, clearly grouped for easy viewing. Each mountpoint shows one RTK Base along with all connected Rovers, giving you a complete picture of your network in real time.</p>
    <p>If no active connections appear, it simply means there are no valid connections at that moment — helping you quickly identify issues. With this powerful monitoring tool, you gain deeper insight into your connection status, making troubleshooting faster and more efficient.</p>
    <p>Best of all, this feature is available to all users, including Free plan members.</p>
  </div>

  <!-- 2nd subsection -->
  <div id="visualize-data" class="wn-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">Visualize Your Mountpoint and RTK Base Data</h2>
    <img src="assets/images/landing/mountpoint_screen.png"
         class="subsection-img"
         alt="Mountpoint Screen"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/mountpoint_screen.png','Mountpoint Screen')">
    <p>When your mountpoint is connected to an RTK base, simply click “Get RTK Base Location” to fetch the latest data. Within minutes, millimeter-level RTK base coordinates are updated and displayed directly on the mountpoint screen.</p>
    <p>View the base station’s position instantly across Google Maps, Bing Maps, Amap, and Baidu Maps, with one-click access to street and satellite views.</p>
    <p>Location history makes it easy to verify accuracy and detect if a base station has been relocated, helping ensure long-term consistency and reliability.</p>
  </div>

  <!-- 3rd subsection -->
  <div id="rtk-analyzer" class="wn-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">RTK Base Analyzer – Full Transparency, Maximum Precision</h2>
    <img src="assets/images/landing/analyzer_screen.png"
         class="subsection-img"
         alt="Analyzer Screen"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/analyzer_screen.png','Analyzer Screen')">
    <p>Take the guesswork out of your GNSS workflow with the GeoAstra RTK Base Analyzer. Designed for surveyors, researchers, and precision mapping professionals, this powerful tool lets you retrieve and monitor your RTK Base information directly from any NTRIP MountPoint. Gain complete visibility into your base station with real-time data, including SNR readings, NTRIP protocol version, and satellite constellations in use. Achieve millimeter-level accuracy with precise horizontal and vertical positioning, track whether your base has been moved with historical location data, and access detailed receiver and antenna descriptors. With the RTK Base Analyzer, you're always in control — ensuring accuracy, consistency, and confidence in every project.</p>
  </div>

  <!-- 4th subsection -->
  <div id="ppk-downloader" class="wn-subsection py-5">
    <h2 class="display-5 lh-1 mb-3">PPK Downloader – PPK Made Simple, Convenient, and Affordable</h2>
    <img src="assets/images/landing/ppk-downloader_screen.png"
         class="subsection-img"
         alt="PPK Downloader Screen"
         loading="lazy"
         (click)="openLightbox('assets/images/landing/ppk-downloader_screen.png','PPK Downloader Screen')">
    <p>Achieve centimeter-level accuracy data logging without the complexity or cost. The PPK Downloader empowers you to download RTK Base correction data (RTCM) directly from any NTRIP CORS mountpoint — no need to operate or own a base station. Focus entirely on Rover data collection while the PPK Downloader handles the base station side for you, cutting equipment costs by 50% or more and saving valuable time. With scheduled downloads, seamless automation, and the ability to log high-precision data anywhere without radios or internet, the PPK Downloader makes professional-grade PPK more accessible, convenient, and reliable than ever before.</p>
  </div>

  <!-- Lightbox overlay -->
  <div *ngIf="lightboxOpen" class="lightbox-backdrop" (click)="closeLightbox()">
    <div class="lightbox-content" (click)="$event.stopPropagation()">
      <button type="button" class="btn-close lightbox-close" aria-label="Close" (click)="closeLightbox()"></button>
      <img [src]="lightboxSrc" [alt]="lightboxAlt" class="img-fluid w-100" />
    </div>
  </div>
</div>
